import React from 'react';
import {useParams, Switch, Route, Redirect} from 'react-router-dom';
import {Form} from 'api';
import Page from './pageId';

interface Props {
  form: Form;
}

export default ({form}: Props) => {
  const {formId} = useParams<{
    formId: string;
  }>();

  return (
    <Switch>
      <Route path="/forms/:formId/pages/:slug">
        <Page form={form} />
      </Route>
      <Redirect to={`/forms/${formId}/pages/${form?.formPages[0].slug}`} />
    </Switch>
  );
};
